export class UserModel {
  family_name: string = '';
  given_name: string = '';
  ipaddr: string = '';
  name: string = '';
  token: string = '';
  username: string = '';
  authenticated: boolean = false;
  error: string = '';
  modifyOps: boolean = false;
  modifyFinance: boolean = false;
}
